import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.css']
})
export class TablaComponent implements OnInit {
  @Input() datos: any = {};
  @Input() paginacion?: boolean;
  @Input() limit?: number;

  columnas: number;
  columnasArray: any[];

  currentPage = 1;
  itemsPerPage: number;
  pageSize: number;


  constructor() {

  }

  ngOnInit() {
    if (this.limit) {
      this.itemsPerPage = this.limit;
    } else {
      this.itemsPerPage = 10;
    }

    this.columnas = this.datos['cabecera'].length;
    this.columnasArray = new Array(this.columnas);
  }


  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  changePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
  }
}
